var React = require('react');
import {USE_HOSTNAME} from '../constants';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import DeleteIcon from '@mui/icons-material/Delete';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DayDialog from "./DayDialog";
import BreakdownDayDialog from "./BreakdownDayDialog";
import WeekPicker from "./WeekPicker";
import MomentUtils from "@date-io/moment";
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import "moment/locale/en-gb";
import { Typography } from '@mui/material';
import moment from "moment";
import { muiThemePicker } from '../mui-theme-design';
import { Stack,CircularProgress } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import Fade from '@mui/material/Fade';
import {logger, muiLoaderOptionsWithoutMUIDataTable} from '../utils';

//export const theme = createTheme();

class Week extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            isLoading: true,
            timeSheet: {                
                week:
                {
                    weekDate: moment(new Date()).weekday(0),
                    weekList: [],
                    History: [],
                    Total: [],
                }
            },
            Labs: []
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDialogCallback = this.handleDialogCallback.bind(this);
        this.handleEditCallback = this.handleEditCallback.bind(this);
        this.handleWeekCallback = this.handleWeekCallback.bind(this);
        this.handleOnClick = this.handleOnClick.bind(this);
    };

    componentDidMount() {
        if (USE_HOSTNAME == "true") {
            //USE_HOSTNAME = location.host
        }
        this.updateWeekList()
    }

    sumStr = (str) => {
        logger(`generating sums`, str)
        let strArr = str.split(",").map(Number);
        logger(`strArr`, strArr)
        let sum = strArr.reduce((total, num) => total + num, 0)
        logger(`sum out`, sum)
        return sum.toFixed(2);;
    };
	
    setweekList = (json) => {
        logger(`setweeklist-input`,json)
        let choices = [];
        json.forEach(choice => choices.push({
            TaskName: choice.TaskName,
            TaskID: choice.TaskID,
            RoleName: choice.RoleName,
            RoleID: choice.RoleID,
            FlagType: choice.FlagType,
            MondayHours: choice.Monday == null ? 0 : parseFloat(this.sumStr(choice.Monday)),
            TuesdayHours: choice.Tuesday == null ? 0 : parseFloat(this.sumStr(choice.Tuesday)),
            WednesdayHours: choice.Wednesday == null ? 0 : parseFloat(this.sumStr(choice.Wednesday)),
            ThursdayHours: choice.Thursday == null ? 0 : parseFloat(this.sumStr(choice.Thursday)),
            FridayHours: choice.Friday == null ? 0 : parseFloat(this.sumStr(choice.Friday)),
            SaturdayHours: choice.Saturday == null ? 0 : parseFloat(this.sumStr(choice.Saturday)),
            SundayHours: choice.Sunday == null ? 0 : parseFloat(this.sumStr(choice.Sunday)),
            WeekOf: choice.WeekOf
        }))
        logger('setweekList',choices)
        this.state.timeSheet.week.weekList = choices;
        this.setState({ state: this.state });
    }

    setTotal = (json) => {
        logger('setTotal', json)
        logger(json.filter(function (item) {
            return item.CurrentUser == json[0].CurrentUser;
        }));
        let choices = json.filter(function (item) {
            return item.ID == json[0].CurrentUser;
        });
        this.state.timeSheet.week.Total = choices;
        this.setState({ state: this.state });
    }

    setHistory = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({
            WeekOf: choice.WeekOf,
            TotalHours:  parseFloat(choice.TotalHours).toFixed(2) 
        }))
        this.state.timeSheet.week.History = choices;
        this.setState({ state: this.state });  
    }

   updateWeekList = async () => {
        logger(this.state.timeSheet.week.weekDate)
       let weekof = this.state.timeSheet.week.weekDate.format('YYYY-MM-DD')

       await fetch(`/api/Summary/${weekof}/${false}`)
           .then(res => res.json())
           .then(json => {
               this.setTotal(json);
           })

        logger(`/api/Time_Entry/${weekof}`)
        await fetch(`/api/Time_Entry/${weekof}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => this.setweekList(json));

        await fetch(`/api/Time/History`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => this.setHistory(json))
            .then(json => this.setState({ isLoading: false }));
    }
    
    handleDialogCallback = (childData) => {

        var TimeEntry = [];
        let weekof = this.state.timeSheet.week.weekDate.format('YYYY-MM-DD')

        
        TimeEntry.push({
            "UserID": childData.UserID,
            "RoleID": childData.RoleID,
            "TaskID": childData.TaskID,
            "WeekOf": weekof,
            "DayOf": childData.DayOf,
            "Hours": childData.Hours,
            "isFlaged": 0,
            "FlagType": childData.TimeType
        })

        logger(TimeEntry);
       fetch("api/Time_Entry", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "time_entry": TimeEntry,
                "time_entry_prop": childData.propList
            })
        })

        logger('childData',childData);
        this.updateWeekList()
    };

    handleEditCallback = () => {
        this.updateWeekList()
        this.setState({ state: this.state });
    };

    handleWeekCallback = (childData) => {
        logger(childData);
        this.state.timeSheet.week.weekDate = childData;
        this.updateWeekList()
        this.setState({ isLoading: true})
        this.setState({ state: this.state });
    }


    handleOnClick = (childData) => {
        logger(childData);
        this.state.timeSheet.week.weekDate = childData;
        this.updateWeekList()
        this.setState({ isLoading: true })
        this.setState({ state: this.state });
    }

    sumHours(project) {
        
        let sum = project.MondayHours + project.TuesdayHours +
            project.WednesdayHours + project.ThursdayHours +
            project.FridayHours + project.SaturdayHours +
            project.SundayHours
        return sum.toFixed(2)
    };

    handleClickOpen = () => {
        this.setState({ open: true})
    };

    handleClose = () => {
        this.setState({ open: false })
    };

    handleSubmit(event) {
        this.setState({ open: false })
        fetch("/api/Time_Entry/Submit", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "Week": this.state.timeSheet.week.weekDate.format("YYYY-MM-DD"),
            })
        })
        event.preventDefault();
    }

    sumDigits(str) {
    const numbers = str.split(',').map(parseFloat);
    const sum = numbers.reduce((acc, num) => acc + num, 0);
    return sum;
}

    render() {
		const { isLoading } = this.state;
        return (
            <form onSubmit={this.handleSubmit}>
                <MuiThemeProvider theme={muiThemePicker}>
	                <TableContainer component={Box}>
	                    <Table sx={{ minWidth: 650 }}>
	                        <TableHead><TableRow>
	                            <TableCell>
	                                <div>
	                                    <MuiThemeProvider theme={muiThemePicker}>
	                                        <MuiPickersUtilsProvider utils={MomentUtils} locale="en">
                                            <WeekPicker handleWeekCallback={this.handleWeekCallback} week={this.state.timeSheet.week.weekDate} />
                                        </MuiPickersUtilsProvider>
                                    </MuiThemeProvider>
                                </div>
                            </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Task</TableCell>
                                <TableCell>Role</TableCell>
                                    <TableCell>{`Mon ${moment(this.state.timeSheet.week.weekDate).format('MM/DD')}`}</TableCell>
                                    <TableCell>{`Tue ${moment(this.state.timeSheet.week.weekDate).add(1, 'days').format('MM/DD')}`}</TableCell>
                                    <TableCell>{`Wed ${moment(this.state.timeSheet.week.weekDate).add(2, 'days').format('MM/DD')}`}</TableCell>
                                    <TableCell>{`Thu ${moment(this.state.timeSheet.week.weekDate).add(3, 'days').format('MM/DD')}`}</TableCell>
                                    <TableCell>{`Fri ${moment(this.state.timeSheet.week.weekDate).add(4, 'days').format('MM/DD')}`}</TableCell>
                                    <TableCell>{`Sat ${moment(this.state.timeSheet.week.weekDate).add(5, 'days').format('MM/DD')}`}</TableCell>
                                    <TableCell>{`Sun ${moment(this.state.timeSheet.week.weekDate).add(6, 'days').format('MM/DD')}`}</TableCell>
                                <TableCell>Total Hours</TableCell>
                            </TableRow>
                        </TableHead>
                            <TableBody>
                                {(isLoading) ? muiLoaderOptionsWithoutMUIDataTable() && <br /> :
                                    <TableRow
                                        key={"Total"}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            Total
                                        </TableCell>
                                        <TableCell component="th" scope="row">

                                        </TableCell>
                                        <TableCell key={"Monday" + "Total"} align="right">{this.state.timeSheet.week.Total[0].Monday == null ? 0 : this.sumDigits(this.state.timeSheet.week.Total[0].Monday).toFixed(2)}</TableCell>
                                        <TableCell key={"Tuesday" + "Total"} align="right">{this.state.timeSheet.week.Total[0].Tuesday == null ? 0 : this.sumDigits(this.state.timeSheet.week.Total[0].Tuesday).toFixed(2)}</TableCell>
                                        <TableCell key={"Wednesday" + "Total"} align="right">{this.state.timeSheet.week.Total[0].Wednesday == null ? 0 : this.sumDigits(this.state.timeSheet.week.Total[0].Wednesday).toFixed(2)}</TableCell>
                                        <TableCell key={"Thursday" + "Total"} align="right">{this.state.timeSheet.week.Total[0].Thursday == null ? 0 : this.sumDigits(this.state.timeSheet.week.Total[0].Thursday).toFixed(2)}</TableCell>
                                        <TableCell key={"Friday" + "Total"} align="right">{this.state.timeSheet.week.Total[0].Friday == null ? 0 : this.sumDigits(this.state.timeSheet.week.Total[0].Friday).toFixed(2)}</TableCell>
                                        <TableCell key={"Saturday" + "Total"} align="right">{this.state.timeSheet.week.Total[0].Saturday == null ? 0 : this.sumDigits(this.state.timeSheet.week.Total[0].Saturday).toFixed(2)}</TableCell>
                                        <TableCell key={"Sunday" + "Total"} align="right">{this.state.timeSheet.week.Total[0].Sunday == null ? 0 : this.sumDigits(this.state.timeSheet.week.Total[0].Sunday).toFixed(2)}</TableCell>
                                        <TableCell key={"Sum" + "Total"} align="right">{this.state.timeSheet.week.Total[0].Total.toFixed(2)}</TableCell>
                                    </TableRow>
                                }
                            {(isLoading) ? muiLoaderOptionsWithoutMUIDataTable() && <br /> :
                                this.state.timeSheet.week.weekList.map((project, index) => (
                                    <TableRow
                                        key={index} 
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            <BreakdownDayDialog handleEditCallback={this.handleEditCallback} data={project} />
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {project.RoleName}
                                        </TableCell>
                                        <TableCell key={"Monday"+index} align="right">{project.MondayHours}</TableCell>
                                        <TableCell key={"Tuesday"+index} align="right">{project.TuesdayHours}</TableCell>
                                        <TableCell key={"Wednesday"+index} align="right">{project.WednesdayHours}</TableCell>
                                        <TableCell key={"Thursday"+index} align="right">{project.ThursdayHours}</TableCell>
                                        <TableCell key={"Friday"+index} align="right">{project.FridayHours}</TableCell>
                                        <TableCell key={"Saturday"+index} align="right">{project.SaturdayHours}</TableCell>
                                        <TableCell key={"Sunday"+index} align="right">{project.SundayHours}</TableCell>
                                        <TableCell key={"Sum"+index} align="right">{this.sumHours(project)}</TableCell>
                                    </TableRow>
                                ))

                            }
                        </TableBody>
                    </Table>
                </TableContainer>

 			{(!isLoading) && (<>
                <div style={{ float: "left" }}>
                    <DayDialog 
                     handleDialogCallback={this.handleDialogCallback} week={this.state.timeSheet.week.weekDate.format('YYYY-MM-DD')} style={{ marginRight: "5px" }} />
                </div> 
               
                <div style={{ float: "left" }}>
                    <Button variant="contained"
                        type="button"
                        className="general-button-blue"
                        style={{ marginRight: "5px", marginLeft: "5px" }}
                        onClick={this.handleClickOpen}
                    >
                        Submit/Lock
                    </Button>
                    <Dialog
                        open={this.state.open}
                        onClose={this.handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >

                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Submit your time for the week?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose}>Cancel</Button>
                            <Button onClick={this.handleSubmit}>Submit</Button>
                        </DialogActions>
                    </Dialog>
                </div>
                </>
                )}

                <TableContainer component={Box}>
                    <Table sx={{ minWidth: 650 }}>
                        <TableHead>
                            <TableCell>
                                <h1>Previous Weeks</h1>
                            </TableCell>
                        
                            <TableRow>
                                <TableCell align="left">Week Of</TableCell>
                                <TableCell align="left">Total Hours</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(isLoading) ? muiLoaderOptionsWithoutMUIDataTable() :
                                    this.state.timeSheet.week.History.map((project,index) => (
                                        
                                    <TableRow
                                        key={'ProjectRow'+index}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                        <TableCell key={'Project-'+index} align="left">
                                            <Button
                                                variant="contained"
                                                className="general-button-blue"
                                                onClick={() => { this.handleOnClick(moment.utc(project.WeekOf));  }}
                                                style={{ marginRight: "5px", marginLeft: "5px" }}>
                                                {moment.utc(project.WeekOf).format("MM/DD/YYYY")}
                                            </Button>
                                        </TableCell>
                                        <TableCell key={'Hours-'+index} align="left">{project.TotalHours}</TableCell>
                                    </TableRow>
                                ))

                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                </MuiThemeProvider> 
            </form>

        );
    }
}


export default Week;
